import React, { Component, PropTypes } from 'react'
import Table from 'react-bootstrap/lib/Table'
import { Fieldset } from 'react-gridforms'
import acc from 'accounting'

import BillingItem from './billing-item'
import FormAddFee from './form-add-fee'

class BillingDetails extends Component {

  constructor(props) {
    super(props)

    this.state = {
      showForm: false,
    }
  }

  _showForm = () => {
    this.setState({
      showForm: true,
    })
  }

  _hideForm = () => {
    this.setState({
      showForm: false,
    })
  }

  render() {
    const { showForm } = this.state
    const { data } = this.props
    const legend = (
      <div>Fees
        <button type="button" onClick={this._showForm} className="btn-inline btn-icon">+</button>
      </div>
    )
    return (
      <div>
        <FormAddFee
          handleClose={this._hideForm}
          isOpen={showForm}
          studentID={data.getIn(['header', 'student_id'])}
        />
        <form className="grid-form">
          <Fieldset legend={legend}>
            <Table hover condensed>
              <thead>
                <tr>
                  <th width="5%"></th>
                  <th width="75%">Fee</th>
                  <th width="20%" className="text-right">Amount (Php)</th>
                </tr>
              </thead>
              <tbody>
                {data.get('reg_billing').map((item, k) => (
                  <BillingItem key={`reg${k}`} item={item} studentID={data.getIn(['header', 'student_id'])} />
                ))}
                {data.get('misc_billing').map((item, k) => (
                  <BillingItem key={`misc${k}`} item={item} studentID={data.getIn(['header', 'student_id'])} />
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan="2" className="text-right">Total Billing:</th>
                  <th className="text-right">{acc.formatNumber(data.getIn(['meta', 'total_amount']), 2)}</th>
                </tr>
              </tfoot>
            </Table>
          </Fieldset>
        </form>
      </div>
    )
  }
}

BillingDetails.propTypes = {
  data: PropTypes.object,
}

export default BillingDetails



// WEBPACK FOOTER //
// ./src/containers/Billing/billing-details.js